/**
 * 응답으로 받은 blob 을 파일로 저장한다.
 *
 * 다운로드 API 는 blob 을 그대로 내려주므로 저장 처리는 화면마다 같다.
 * (공지 상세 / 공지 팝업 / OTP 등록 안내에서 함께 사용한다)
 *
 * @param data     axios 응답 data (responseType: "blob")
 * @param fileName 저장할 파일명
 */
export const saveBlobAsFile = (data, fileName) => {
  const url = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement("a");

  link.href = url;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};
